import { Component, inject, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TokenService } from '../../../services/token.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { TranslationService } from '../../../services/translation.service';
import { Router } from '@angular/router';
import { CanActionDirective } from '../directives/can-action.directive';
import { ACTIONS } from '../../../constants/permissions.constants';
import {
  MsalService,
  MsalModule,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
} from '@azure/msal-browser';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule, TranslatePipe, CanActionDirective],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TopbarComponent {
  readonly ACTIONS = ACTIONS;
  private translationService = inject(TranslationService);
  private router = inject(Router);
  private tokenService = inject(TokenService);
  private cdr = inject(ChangeDetectorRef);

  nombreUsuario: string = 'Usuario';
  activeLang: string = 'es';

  menu: any[] = [];

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    this.obtenerNombreUsuario();

    // Suscribirse a cambios de idioma y actualizar menú
    this.translationService.getTranslations().subscribe(() => {
      this.definirMenu();
      setTimeout(() => {
        this.cdr.detectChanges();
      });
    });

    this.definirMenu(); // Definir el menú al inicio
  }

  definirMenu() {
    this.menu = [
      {
        iconName: 'module-order-product-catalogue',
        label: this.nombreUsuario,
        active: false,
        clickFn: () => console.log('Menú activado'),
        children: [
          {
            label: this.translationService.translate('spanish'), // Se traduce dinámicamente
            clickFn: () => this.changeLanguage('es'),
          },
          {
            label: this.translationService.translate('english'),
            clickFn: () => this.changeLanguage('en'),
          },

          {
            label: this.translationService.translate('logout'),
            clickFn: () => this.cerrarSesion(),
          },
        ],
      },
    ];
  }


  changeLanguage(lang: string) {
    console.log('Cambiando idioma a:', lang);
    this.activeLang = lang;
    this.translationService.setLanguage(lang);
    this.definirMenu(); // Actualizar el menú
    this.cdr.detectChanges(); // 🚀 Forzar actualización de la UI
  }

  obtenerNombreUsuario() {
    const userData = sessionStorage.getItem('userData');
    if (userData) {
      const user = JSON.parse(userData);
      this.nombreUsuario = user.username || 'Usuario';
    }
  }

  cerrarSesion2() {
    this.tokenService.removeToken();
    sessionStorage.removeItem('userData');
    this.router.navigate(['/login']);
  }

  cerrarSesion(popup?: boolean) {
    localStorage.clear();
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
